/*** IMPORTS FROM imports-loader ***/
var global = window;

export default '00000000-0000-0000-0000-000000000000';
